<template>
    <painel-component :itens="itensOne">
        <error-component :errors="errors" v-if="showError"/>
        <loder-send-component :text-title="'Carregando'" v-if="showLoader"/>

        <form autocomplete="off" v-else>
            <row-component>
                <row-col-component :class-row-col="'col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.name }">
                    <label>Nome:</label>
                    <input-component disabled :maxlength=100 :type-input="'text'" v-model="formDate.name"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.sector }">
                    <label>Setor:</label>
                    <Multiselect disabled v-model="formDate.sector" :searchable="true" :options="selectSector"
                                 :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.responsibles }">
                    <label>Responsáveis:</label>
                    <Multiselect disabled v-model="formDate.responsibles" mode="tags" track-by="name" label="name"
                                 :options="selectUserList" :searchable="true"
                                 :noResultsText="noResultsText" :noOptionsText="noResultsText" :close-on-select="false"
                                 :search="true">
                        <template v-slot:tag="{ option, handleTagRemove, disabled }">
                            <div class="multiselect-tag is-user" :class="{ 'is-disabled': disabled }">
                                <img :src="option.icon" alt="">
                                {{ option.name }}
                                <span v-if="!disabled" class="multiselect-tag-remove"
                                      @mousedown.prevent="handleTagRemove(option, $event)">
                                    <span class="multiselect-tag-remove-icon"></span>
                                </span>
                            </div>
                        </template>

                        <template v-slot:option="{ option }">
                            <img class="character-option-icon" :src="option.icon" alt=""> {{ option.name }}
                        </template>
                    </Multiselect>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.frequency }">
                    <label>Periodicidade:</label>
                    <Multiselect disabled v-model="formDate.frequency" :searchable="true" :options="selectFrequency"
                                 :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.status }">
                    <label>Status:</label>
                    <Multiselect disabled v-model="formDate.status" :searchable="true" :options="selectInput"
                                 :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.start_date }">
                    <label>Data Início:</label>
                    <input-component disabled v-mask="'##/##/####'" :type-input="'text'" v-model="formDate.start_date"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.closing_date }">
                    <label>Data Encerramento:</label>
                    <input-component disabled v-mask="'##/##/####'" :type-input="'text'"
                                     v-model="formDate.closing_date"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.desc }">
                    <label>Descrição:</label>
                    <QuillEditor :theme="'bubble'" :contentType="'html'" ref="myEditor" v-model:content="formDate.desc"
                                 style="min-height: 150px; margin-bottom: 2%; border:1px solid #1b1c1d"
                                 :readOnly="true"/>
                </row-col-component>
            </row-component>
        </form>

        <row-component>
            <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4'">
                <button-float class="w-100" :itens="itensTwo"/>
            </row-col-component>
        </row-component>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import InputComponent from "@/components/form/InputComponent";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import Multiselect from "@vueform/multiselect";
import ErrorComponent from "@/components/alerts/ErrorComponent"
import LoderSendComponent from "@/components/LoderSendComponent";
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

import {mask} from 'vue-the-mask'
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "ScheduledNoteShow",
    components: {
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        ButtonFloat,
        Multiselect,
        ErrorComponent,
        LoderSendComponent,
        QuillEditor
    },

    directives: {
        mask
    },

    props: {
        id: {
            required: true
        }
    },

    created() {
        this.checkACL()
        this.loadPageItens()
        this.$store.dispatch('loadUserListSelect')
        this.$store.dispatch('updateNamePage', 'Anotações Agendadas')
    },

    data() {
        return {
            itensOne: {
                title: "Ver",
                icon: "eye"
            },

            itensTwo: {
                route: "/scheduled-note/search",
                icon: "reply all",
                name: 'Voltar'
            },

            formDate: {
                name: '',
                sector: '',
                status: '',
                frequency: '',
                start_date: '',
                closing_date: '',
                desc: '',
                responsibles: []
            },

            errors: [],
            showError: false,
            sendForm: false,
            showLoader: true,

            toolbarOptions: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{'header': 1}, {'header': 2}],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'script': 'sub'}, {'script': 'super'}],
                [{'indent': '-1'}, {'indent': '+1'}],
                [{'direction': 'rtl'}],
                [{'size': ['small', false, 'large', 'huge']}],
                [{'header': [1, 2, 3, 4, 5, 6, false]}],
                [{'color': []}, {'background': []}],
                [{'font': []}],
                [{'align': []}],
                ['clean']
            ],
        }
    },

    methods: {
        loadPageItens() {
            this.$store.dispatch('loadScheduledNote', this.id)
                .then((r) => {
                    this.formDate = r;
                    this.$refs.myEditor?.setHTML(r.desc)
                }).catch(() => {
                toast.error("Erro desconhecido !", {timeout: 2000});
            })
        },

        scrollTop() {
            window.scrollTo(0, 0)
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 34)
                .then((r) => {
                    if (r.data.indexOf('note-schedule-search') !== -1) {
                        this.showLoader = false
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },
    },

    computed: {
        noResultsText() {
            return this.$store.state.var.selectNotSearch
        },

        selectSector() {
            return this.$store.state.var.selectSector
        },

        selectUserList() {
            return this.$store.state.var.selectUserList;
        },

        selectFrequency() {
            return this.$store.state.var.selectFrequency;
        },

        selectInput() {
            return this.$store.state.var.selectActiveInactive;
        }
    }
}
</script>

<style scoped>
#quillEditor {
    min-height: 700px;
}

.character-label-icon,
.character-option-icon {
    height: 20px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 10px;
}
</style>